import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment } from "@angular/router";
import { tap } from "rxjs/operators";
import { XeroService } from "../xero.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad, CanActivate {
  constructor(private xero: XeroService) { }

  canLoad(route: Route, segments: UrlSegment[]) {
    let destRoute = `/${segments.filter(x => x.path).join('/')}`;

    console.debug(`Client attempts to load module at route ${destRoute}`);
    return this.xero.status$.pipe(tap((isPermitted) => {
      isPermitted
        ? console.debug(`Client allows access to module at route ${destRoute}`)
        : console.warn(`Client denies access to module at route ${destRoute}`);
    }));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.debug(`Client attempts to load component at route ${state.url}`);
    return this.xero.status$.pipe(tap((isPermitted) => {
        isPermitted
          ? console.debug(`Client allows access to component at route ${state.url}`)
          : console.warn(`Client denies access to component at route ${state.url}`);
    }));
  }
}
